import { atom } from 'recoil'

export const pageState = atom({
  key: 'dynamicContentListState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    isDirty: false,
    isEmptyState: true
  }
})
export const integrationsState = atom({
  key: 'IntegrationsState',
  default: {
    loaded: false,
    loading: true,
    error: false,
    items: []
  }
})
export const resultsState = atom({
  key: 'ResultsState',
  default: {
    loadingTable: true,
    items: []
  }
})
export const defaultSearchState = atom({
  key: 'DefaultSearchState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    status: null,
    orderBy: 'CreationDate',
    orderDescending: true
  }
})
export const searchState = atom({
  key: 'SearchState',
  default: defaultSearchState
})

export const modalDeleteState = atom({
  key: 'modalListDelete',
  default: {
    show: false,
    id: undefined,
    title: undefined
  }
})
